/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {SpeciesTableDeltaColumn} from "./SpeciesTableDeltaColumn";
import React, {Fragment} from "react";
import {Glyphicon} from "../../../../Common/GlyphIcon";

export function SpeciesTableLatinNameColumn(props) {
    const {
		rowData: species = {},
	    OnDeleteClick,
	    OnEditClick,
	    OnQuickAdd,
	    showGlobalIcon = false
	} = props;
	const isUnused = species?.SpeciesListSpecies?.speciesId == null || species?.SpeciesListSpecies?.deleted;
	const id = species?.speciesId;
	const slsId = species?.SpeciesListSpecies?.speciesListSpeciesId;
	
	if (OnEditClick) {
		return <Fragment>
			{
				species?.SpeciesListSpecies ?
					<div className="float-right">
						{
							species?.SpeciesListSpecies?.deleted ?
								<a className="text-primary" onClick={_ => OnDeleteClick?.(slsId)}>
									<Glyphicon glyph="plus-sign" title="Add this species to the custom list."/>
								</a> :
								<a className="text-danger" onClick={_ => OnDeleteClick?.(slsId)}>
									<Glyphicon style={{color: "red"}} glyph="remove-sign" title="Remove this species from the custom list."/>
								</a>
						}
					</div> :
					OnQuickAdd ?
						<div className="float-right">
							<a className="text-primary" onClick={_ => OnQuickAdd?.(id)}>
								<Glyphicon glyph="plus-sign"/>
							</a>
						</div> :
						null
			}
			<div className="sb-species-delta-table-column-editable" onClick={_ => OnEditClick?.(id)}>
				<a className="link-primary" title={`Species ID ${species?.speciesId}`}>
					{
						(showGlobalIcon && isUnused) ?
						<Glyphicon className="sb-species-type-icon-in-table" glyph="globe" title="This species is from the global species list."/>
						: null
					}
					<SpeciesTableDeltaColumn {...props} />
				</a>
			</div>
		</Fragment>;
	} else {
		return <SpeciesTableDeltaColumn {...props} />;
	}
}